import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseConfig';

/**
 * Get current user's credit balance
 */
export const getUserCredit = async () => {
  try {
    const fn = httpsCallable(functions, 'getUserCredits');
    const result = await fn({});
    return {
      success: true,
      credit: result.data.balance
    };
  } catch (error) {
    console.error('[CREDIT SERVICE] Error fetching user credit:', error);
    if (error.code === 'functions/unauthenticated') {
      return { success: false, error: 'Authentication required' };
    }
    return { success: false, error: error.message || 'Failed to fetch credit balance' };
  }
};

/**
 * Create a Stripe checkout session for purchasing credits
 */
export const createCheckoutSession = async (credits) => {
  try {
    const fn = httpsCallable(functions, 'createCheckoutSession');
    const result = await fn({ credits });
    return {
      success: true,
      url: result.data.url,
      sessionId: result.data.sessionId
    };
  } catch (error) {
    console.error('[CREDIT SERVICE] Error creating checkout session:', error);
    return { success: false, error: error.message || 'Failed to create checkout session' };
  }
};

/**
 * Verify a checkout session (for success page)
 */
export const verifyCheckoutSession = async (sessionId) => {
  try {
    const fn = httpsCallable(functions, 'verifyCheckoutSession');
    const result = await fn({ sessionId });
    return {
      success: true,
      ...result.data
    };
  } catch (error) {
    console.error('[CREDIT SERVICE] Error verifying session:', error);
    return { success: false, error: error.message || 'Failed to verify session' };
  }
};

/**
 * Initialize credits for new user (grants free credits on first login)
 */
export const initializeCredits = async () => {
  try {
    const fn = httpsCallable(functions, 'initializeUserCredits');
    const result = await fn({});
    return {
      success: true,
      balance: result.data.balance,
      isNewUser: result.data.isNewUser
    };
  } catch (error) {
    console.error('[CREDIT SERVICE] Error initializing credits:', error);
    return { success: false, error: error.message || 'Failed to initialize credits' };
  }
};
